module.exports = __webpack_public_path__ + "media/images/sp/stores/nagoya/access/nagoya_point3_2-adbb051a4cbee0e894e781954c61a578.jpg";